"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromotionTypeEnum;
(function (PromotionTypeEnum) {
    PromotionTypeEnum["BANNER"] = "BANNER";
    PromotionTypeEnum["PROMOTED"] = "PROMOTED";
})(PromotionTypeEnum = exports.PromotionTypeEnum || (exports.PromotionTypeEnum = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvbW90aW9uLXR5cGUuZW51bS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lbnVtcy9wcm9tb3Rpb24tdHlwZS5lbnVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBWSxpQkFHWDtBQUhELFdBQVksaUJBQWlCO0lBQzNCLHNDQUFpQixDQUFBO0lBQ2pCLDBDQUFxQixDQUFBO0FBQ3ZCLENBQUMsRUFIVyxpQkFBaUIsR0FBakIseUJBQWlCLEtBQWpCLHlCQUFpQixRQUc1QiJ9